<template>
  <div>
    <h1 id="myH1">我是store里面a的值: {{$store.state.a}}- {{$store.state.user.a}}--{{$store.state.app.a}}</h1>
    <h1>我是store里面b的值: {{b}}</h1>
    <h1>我是myname: {{myName}}</h1>
    <h1>我是name: {{$store.state.name}}</h1>
    <h1>通过mapState获取的name值: {{myName}}--{{c}}</h1>
    <h2>person的name的值是: {{person.name}}</h2>
    <button type="button" @click="setAValue">设置a的值</button>
    <hr>

    <div>{{ $store.state.count }}</div>
    <span v-pre>{{ this will not be compiled }}</span>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  export default {
    data() {
      return {
        person: {}
      }
    },
    

    created() {
      let { commit } = { commit: function () {

        },getter:function(){}}

      
      this.test()
    },
    computed: {
      ...mapState({
        myName: state => state.name+"11",
        c: state => { return state.c }
      }),
      ...mapGetters(['b'])
    },
    methods: {
      test(){
        this.$store.commit('increment')
        console.log(this.$store.state.count) // -> 1
      },


      ...mapMutations(['SET_A']),
      ...mapActions({
        add: 'action_set_a' // 将 `this.add()` 映射为 `this.$store.dispatch('increment')`
      }),
      setAValue() {
        // this.SET_A(10)
        // console.log(document.getElementById('myH1').innerHTML)
        // this.person.name = '123123123'
        // this.$store.state.a = 10
        // this.$store.commit('SET_A', 10)
        // this.$store.commit('SET_Usera', 20)
        // this.$store.dispatch('action_set_a', 20)
        this.add(20)
      }
    }
  }
</script>
